module.exports = __webpack_public_path__ + "img/blue_check.17744745.png";